// DSPs
export const INDEX_REQUEST: string = "Dsps/INDEX_REQUEST";
export const INDEX_SUCCESS: string = "Dsps/INDEX_SUCCESS";
export const INDEX_FAILURE: string = "Dsps/INDEX_FAILURE";
